
import { Button } from 'components/ui/button';
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from 'components/ui/dialog';

import { t } from '@lingui/macro';

export default function ConfirmationDialog({
    open,
    onClose,
    onConfirm,
    title,
    message,
    confirmLabel = t`Confirm`,
    cancelLabel = t`Cancel`,
}) {
    return (
        <Dialog
            open={open}
            onOpenChange={(next) => {
                if (!next) {
                    onClose();
                }
            }}
        >
            <DialogContent className="sm:max-w-md">
                <DialogHeader>
                    <DialogTitle>{title}</DialogTitle>
                    <DialogDescription>{message}</DialogDescription>
                </DialogHeader>
                <DialogFooter className="gap-2 sm:gap-0">
                    <Button
                        type="button"
                        variant="outline"
                        className="border-destructive text-destructive hover:bg-destructive/10 hover:text-destructive"
                        onClick={onConfirm}
                    >
                        {confirmLabel}
                    </Button>
                    <Button type="button" variant="default" className="shadow-none" onClick={onClose}>
                        {cancelLabel}
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
